(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('./enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new', function (metricsNew) {
            metricsNew.DataSourceFilterGroups = exportFn(
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(DataSourceFilterGroupIds) {
        return {
            [DataSourceFilterGroupIds.company]: {
                landscapeId: {},
                focusCompanyId: {},
                companyFilter: {}, // companySetDescriptor
                onlyCompanyIds: {}, // only include these companyIds
                onlyCompanySetIds: {} // only include these companySetIds
            },
            [DataSourceFilterGroupIds.source]: {
                excludedSourceIds: {},
                onlySourceIds: {}
            },
            [DataSourceFilterGroupIds.timePeriod]: {
                startDate: {},
                endDate: {},
                timezone: {}
            },
            [DataSourceFilterGroupIds.timezone]: {
                name: {}
            },
            [DataSourceFilterGroupIds.publicPost]: {
                postIds: {}, // list of socialPostIds; posts returned must still match all the other filters
                searchTerm: {},
                canonicalUrlFilter: {},
                primaryDomainFilter: {},
                mediaTypes: {},
                mediaTypeGroups: {}, // higher-level filter for mediaTypes
                tweetTypes: {},
                promotedPosts: {}, // The list of valid values for this is: likelyPromoted.filterTypes
                excludePostsWithoutLinks: {},
                canonicalUrlExactMatch: {},

                postTagIds: {},
                postTagConjunction: {},
                postTagExclude: {},

                minDistinctCompanyIds: {},
                minDistinctPostIds: {},
                elideZeroPostsCompanies: {},

                mustHavePostTagIds: {},
                excludeNullPosts: {}
            },
            [DataSourceFilterGroupIds.ordering]: {
                // sort is an array of objects where each object has a `measure` and `sortOrder` (which must be either 'asc' or 'desc')
                sort: {},
                limit: {}
            },
            [DataSourceFilterGroupIds.listening]: {

                // NOTE either listeningQueryId, searchTerms, or landscapeId is required (only one of these should be specified).
                // If landscapeId is specified, listeningQueryId must be one of the dimensions.
                listeningQueryId: {},
                searchTerms: {},
                landscapeId: {},

                // TODO: should these next three be in a separate filter group?
                // sampleSavedSearches is a boolean; if you specify true, that only makes sense if landscapeId and accountSavedSearches are not specified and listeningQueryId is the free dimension.
                sampleSavedSearches: {},

                // accountSavedSearches is a boolean; if you specify true, that only makes sense if landscapeId and sampleSavedSearches are not specified and listeningQueryId is the free dimension.
                accountSavedSearches: {},

                // option array of listeningQueryTypes; if specified, only topics of these types will be returned.
                listeningQueryTypes: {},

                matchNone: {},

                // an array of arrays of keyword terms
                searchTermsAnd: {},

                // an array of phrases, which are ORed together
                searchTermsNot: {},

                // NOTE max number of results for post and top N requests
                limit: {},

                // a double array of advancedFilters, where the first level is ANDed and the second level is ORed.
                // this filter will be used to generate an advancedFilter, described in Insight API document.
                // for example, [['theme:111', 'theme:222'], ['theme:333'], ['(theme:444 AND theme:555)']] will generate an advancedFilter of '(theme:111 OR theme:222) AND theme:333 AND (theme:444 AND theme:555)'.
                advancedFilterBuilder: {},

                // additional filters; see the Quid Monitor documentation for valid values
                language: {},
                source: {},
                sentiment: {},
                geo: {},
                theme: {},

                phrase: {},
                domain: {},
                excludeDomain: {},
                hashtag: {},
                person: {},
                brand: {},
                gender: {},

                author: {},
                excludeAuthor: {},

                like: {},
                dislike: {},
                positiveEmotion: {},
                negativeEmotion: {},
                positiveBehavior: {},
                negativeBehavior: {},

                advancedFilter: {}

                // NOTE there are more filters we can add here as needed
            }
        };
    }
})();
